import PlayerRpeListItem from "@/app/activity/components/upsertActivityDialog/TabPlayerRpe/PlayerRpeListItem"

import { useTranslation } from "react-i18next"

import "./tabPlayerRpe.scss"
import { PlayerData } from "@/types/player"
import { Dispatch, SetStateAction } from "react"

export default function TabPlayerRpe({
  playerRpeList,
  updatePlayerRpeList,
}: {
  playerRpeList?: PlayerData[]
  updatePlayerRpeList: Dispatch<SetStateAction<PlayerData[]>>
}) {
  const { t } = useTranslation()

  const updatePlayerRpe = (index: number) => {
    return function (item: PlayerData) {
      const newPlayerRpeList = [...(playerRpeList || [])]
      newPlayerRpeList[index] = item
      updatePlayerRpeList(newPlayerRpeList)
    }
  }

  return (
    <div className="TabPlayerRpe">
      <div className="TabPlayerRpe-header">
        <span className="TabPlayerRpe-header-player-name">{t("player")}</span>
        <span className="TabPlayerRpe-header-player-position">{t("position")}</span>
        <span className="TabPlayerRpe-header-player-group">{t("playerGroup")}</span>
        <span className="TabPlayerRpe-header-player-rpe">{t("metric.rpe")}</span>
      </div>
      {playerRpeList?.map((player, index) => (
        <PlayerRpeListItem
          key={`${player.idfPlayer}_${index}`}
          {...player}
          updatePlayerRpe={updatePlayerRpe(index)}
        />
      ))}
    </div>
  )
}
